import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleAddLab({ payload }) {
  try {
    const labData = { ...payload.data };
    const fileKeys = ["contract", "testingScope"];

    // Upload files to Azure Blob Storage
    for (const key of fileKeys) {
      const file = payload.data[key];
      if (!file) continue;

      // Generate unique filename to prevent collisions
      const timestamp = Date.now();
      const sanitizedLabName = (payload.data.name || "lab")
        .replace(/[^a-zA-Z0-9-_]/g, "_")
        .substring(0, 30);
      
      // Extract file extension and base name safely
      const lastDotIndex = file.name.lastIndexOf(".");
      const fileExtension = lastDotIndex > 0 
        ? file.name.substring(lastDotIndex) 
        : "";
      const baseFileName = lastDotIndex > 0
        ? file.name.substring(0, lastDotIndex)
        : file.name;
      const sanitizedFileName = baseFileName
        .replace(/[^a-zA-Z0-9-_]/g, "_")
        .substring(0, 30);
      
      const uniqueBlobName = `${sanitizedLabName}_${timestamp}_${sanitizedFileName}${fileExtension}`;

      // Get SAS token URL from backend
      const fileUrlResponse = yield call(APIS.getFileUrl, {
        blobName: uniqueBlobName,
        source: { name: process.env.REACT_APP_ENVIRONMENT },
      });

      const uploadUrl = fileUrlResponse.data?.data?.document;
      if (!uploadUrl) {
        throw new Error("Failed to get file upload URL");
      }

      // Upload file to Azure Blob Storage
      const uploadResponse = yield call(APIS.uploadFile, {
        data: file,
        url: uploadUrl,
      });

      if (uploadResponse.status < 200 || uploadResponse.status >= 300) {
        throw new Error("Failed to upload file");
      }

      // Store the unique filename (backend will construct full path on download)
      labData[key] = uniqueBlobName;
    }

    // Create lab partner with uploaded file paths
    const response = yield call(APIS.addLab, labData);
    yield put(actions.addLabSuccess(response.data));

    payload.onSuccess?.();
  } catch (err) {
    // Determine error message based on error type
    console.error("Error adding lab partner:", err);
    let errorMessage;
    if (err?.response?.status === 500) {
      errorMessage = { message: "Something has gone wrong on the web site's server." };
    } else if (err?.response?.data) {
      // Ensure response data has message property
      errorMessage =  errorMessage = err.response.data;
    } else {
      errorMessage = { message: err.message || "An error occurred while adding lab partner" };
    }

    yield put(actions.addLabFailure(errorMessage));
    payload.onFailure?.();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* labAddSaga() {
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.addLab.type, handleAddLab);
}
